<script lang="ts" setup>
import { ref } from 'vue';
import HighlightBox from '@/molecules/HighlightBox.vue';
import BaseLabel from '@/atoms/BaseLabel.vue';
import { useScore2 } from '@/parcours/flows/mcv/useScore2';

// 👉 props (recommandé dans ton flow)
const props = defineProps<{
  data: any;
  request: any;
}>();
// 👉 on rend reactive
const coordinatorPatientMcv = ref(props.data);

// 👉 useScore2
const { score2, scoreColor } = useScore2(coordinatorPatientMcv?.value?.request);

// 👉 rows (inchangé)
const scoreRows = [
  {
    label: 'Age',
    value: 'Par intervalle de 5 ans, disponible à partir de 40 ans pour SCORE2',
  },
  {
    label: 'Genre',
    value: 'Homme ou Femme',
  },
  {
    label: 'TA',
    value: 'Valeur en mmHg',
  },
  {
    label: 'Tabac',
    value: 'Oui / Non',
  },
  {
    label: 'Taux cholestérol',
    value: 'Valeur en mmHg',
  },
];
</script>
<template>
  <div>
    <!-- 🔥 SCORE DYNAMIQUE -->
    <HighlightBox :color="scoreColor" :value="score2 ?? '--'" class="mb-6 mt-6" suffix="%" />

    <BaseLabel
      color="primary"
      preset="medium"
      text="Le calcul d'un score de risque cardiovasculaire permet d'identifier les facteurs de risque sur lesquels on peut agir par une modification des habitudes et du mode de vie, parfois complétée par un traitement dans le cas d'un diabète, d'une HTA, ou d'une hypercholestérolémie."
      weight="regular"
    />

    <div class="mt-6">
      <BaseLabel
        color="primary"
        preset="medium"
        text="Interprétation du score de risque"
        weight="medium"
      />
    </div>

    <BaseLabel
      color="secondary"
      preset="medium"
      text="Les variables de ce score sont :"
      weight="regular"
    />

    <div class="flex flex-col">
      <article
        v-for="(row, index) in scoreRows"
        :key="index"
        class="w-full border-b border-secondary py-4"
      >
        <div class="grid grid-cols-[1fr_2fr] items-start gap-4">
          <BaseLabel :text="row.label" color="secondary" preset="medium" weight="regular" />

          <BaseLabel
            :text="row.value"
            class="text-left"
            color="primary"
            preset="medium"
            weight="regular"
          />
        </div>
      </article>
    </div>
  </div>
</template>
